@if(config.typeTable?.type === 'table') {
<div class="table-wrapper">
    <div class="table-container">
        <p-table
            [columns]="columns"
            [value]="rows"
            [rowsPerPageOptions]="pageSizeOptions"
            [rows]="datasource.tablePage.size"
            [dataKey]="config.dataKey"
            [loading]="isLoading$ | async"
            [totalRecords]="datasource.tablePage.totalElements"
            [lazy]="paginationServerSide"
            (selectionChange)="onSelected($event)"
            (onLazyLoad)="onLazyLoad($event)"
            [sortMode]="config.sortMode"
            (onSort)="changeSort($event)"
            [paginator]="false"
        >
            <ng-template pTemplate="header" let-columns>
                <tr>
                    @for (col of columns; track col.colId) { @if (col.checkboxable && showCheckbox) {
                    <th scope="col"><p-tableHeaderCheckbox class="me-3"></p-tableHeaderCheckbox></th>
                    } @if (col.sortable) {
                    <th [style.width.%]="col.width" scope="col" pSortableColumn="{{ col.colId }}">
                        <span [class]="col.wrapWords ? 'space-initial' : ''">
                            {{ col.label | translate }}
                        </span>
                        <p-sortIcon [field]="col.colId"></p-sortIcon>
                    </th>
                    } @else {

                    <th scope="col" [style.width.%]="col.width">
                        <span [class]="col.wrapWords ? 'space-initial' : ''">
                            {{ col.label | translate }}
                        </span>
                    </th>
                    } }
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
                @if (rows.length) {
                <tr>
                    @for (col of columns; track col.colId) { @if (col.checkboxable && showCheckbox) {
                    <td>
                        <p-tableCheckbox [value]="rowData" class="me-3"></p-tableCheckbox>
                    </td>
                    }
                    <td [style.width.%]="col.width">
                        @if (col.cellTemplate) {
                        <ng-container
                            *ngTemplateOutlet="col.cellTemplate; context: { $implicit: rowData }"
                        ></ng-container>
                        } @else {
                        <span [class]="col.wrapWords ? 'space-initial' : ''">
                            {{ rowData | deepObject : col.prop | dynamicPipe : col.pipe : col.pipeArgs || [] }}
                        </span>
                        }
                    </td>
                    }
                </tr>
                } @else {
                <tr>
                    <td [attr.colspan]="columns?.length ? columns.length : 1" class="text-center">
                        {{ fetchError ?? 'UTILS.TABLE.EMPTY' | translate }}
                    </td>
                </tr>
                }
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [attr.colspan]="columns ? columns.length : 1" class="text-center">
                        <img [src]="appBasePath + '/svg/no-data-table.svg'" alt="User" />
                        <div class="row">
                            <div class="col-12">
                                <strong>{{ config.emptyMessage?.title }}</strong>
                            </div>
                            <div class="col-12">
                                <p>{{ config.emptyMessage?.subtitle }}</p>
                            </div>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
} @else {
<div class="table-wrapper">
    <div class="table-container">
        @if(isLoading$ | async) {
        <div class="row">
            <div class="col-12 d-flex justify-content-center mt-3 mb-3">
                <p-progressSpinner ariaLabel="loading" />
            </div>
        </div>
        } @else { @if (rows.length) {
        <div class="row">
            <div *ngFor="let item of rows; let i = index" class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
                <ng-container
                    *ngTemplateOutlet="config.typeTable?.template ?? null; context: { $implicit: item, index: i }"
                >
                </ng-container>
            </div>
        </div>
        } @else {
        <div class="text-center">
            <img [src]="appBasePath + '/svg/no-data-table.svg'" alt="User" class="w-25" />
            <div class="row">
                <div class="col-12">
                    <strong>{{ config.emptyMessage?.title }}</strong>
                </div>
                <div class="col-12">
                    <p>{{ config.emptyMessage?.subtitle }}</p>
                </div>
            </div>
        </div>
        } }
    </div>
</div>

} @if(config.pagination) {
<div class="border-top-separator">
    <p-paginator
        (onPageChange)="onPageChangePaginator($event)"
        [rows]="datasource.tablePage.size"
        [totalRecords]="datasource.tablePage.totalElements"
        [rowsPerPageOptions]="pageSizeOptions"
    />
</div>
}
